import { Provider } from "@redotech/redo-model/order";
import { ProductInfo, ProductStatus } from "@redotech/redo-model/product";
import * as z from "zod/v4";

export const searchProducts = {
  name: "searchProducts" as const,
  input: z.object({
    searchString: z.string(),
    provider: z.enum(Provider),
    first: z.number().optional(),
    includeStatuses: z.array(z.enum(ProductStatus)).optional(),
  }),
  output: z.object({ products: z.array(ProductInfo) }),
};
